import React from "react"
import "../header/header.scss"
import SearchForm from "../ui/forms/searchForm/searchForm"
import NotificationsDropdown from "../ui/dropdowns/notificationsDropdown/notificationsDropdown"
import UserDropdownMenu from "../ui/dropdowns/userDropdownMenu/userDropdownMenu"
import { generatePath, Link, NavLink, withRouter } from "react-router-dom"
import { bindActionCreators } from "redux"
import { signOut } from "../../library/store/actions/creators/authCreators"
import {
  clearNotificationCount,
  clearNotificationSmallList,
  decrementUnreadCount,
  deleteNotification,
  getNotificationSmallList,
  updateNotificationList,
} from "../../library/store/actions/creators/notificationCreators"
import { connect, shallowEqual, useSelector } from "react-redux"
import { usersSearch } from "../../library/store/actions/creators/searchCreators"
import logo from "../../assets/img/logo.svg"
import styled from "@emotion/styled"
import { shadows } from "../../library/constants/styles/shadows"
import { colors } from "../../library/constants/styles/colors"
import {
  BOOKMARKS,
  CONVERSATIONS,
  FEED,
  GROUPS,
  HOME,
  USER,
} from "../../library/constants/routes"
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined"
import SubjectOutlinedIcon from "@material-ui/icons/SubjectOutlined"
import ChatBubbleOutlineOutlinedIcon from "@material-ui/icons/ChatBubbleOutlineOutlined"
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined"
import SupervisedUserCircleOutlinedIcon from "@material-ui/icons/SupervisedUserCircleOutlined"
import BookmarksOutlinedIcon from "@material-ui/icons/BookmarksOutlined"
import { mq } from "../../theme/globalStyle"

const Container = styled.header`
  position: relative;
  display: flex;
  z-index: 100;
  width: 100%;
  box-shadow: ${shadows.layout};
  background-color: ${colors.white};

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr minmax(min-content, 1200px) 1fr;
    width: auto;
  }
`

const Nav = styled.nav`
  margin-left: 30px;

  ${mq.xs} {
    display: none;
  }
`

const NavList = styled.ul`
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
`

const NavListItem = styled.li`
  color: ${colors.black54};

  &:not(:last-of-type) {
    margin-right: 30px;
  }
`

const NavListLink = styled(NavLink)`
  transition: color 0.2s;

  &:hover {
    color: ${colors.primary};
  }
`

const HeaderLoggedIn = (props) => {
  const { userData } = useSelector(({ auth }) => auth)

  const showNotifications = !!userData && !userData.deleted && !userData.blocked

  const { chatsCounter } = useSelector(
    ({ notifications }) => notifications,
    shallowEqual
  )

  const navItems = [
    {
      path: HOME,
      label: "Calendar",
      Icon: HomeOutlinedIcon,
    },
    !!userData && {
      path: generatePath(USER, { userId: userData.id }),
      label: "My Page",
      Icon: AccountCircleOutlinedIcon,
    },
    {
      path: FEED,
      label: "News",
      Icon: SubjectOutlinedIcon,
    },
    {
      path: CONVERSATIONS,
      label: !chatsCounter ? (
        "Chats"
      ) : (
        <span className={"font-12"}>
          Chats{" "}
          <span className={"color-primary font-weight-500"}>
            (+{chatsCounter})
          </span>
        </span>
      ),
      Icon: ChatBubbleOutlineOutlinedIcon,
    },
    {
      path: generatePath(GROUPS, { userId: userData.id }),
      label: "Groups",
      Icon: SupervisedUserCircleOutlinedIcon,
    },
    {
      path: BOOKMARKS,
      label: "Bookmarks",
      Icon: BookmarksOutlinedIcon,
    },
  ].filter(Boolean)

  return (
    <Container>
      <div className="header__content header__content--default container">
        <div>
          <Link to={HOME} className="header__logo">
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        <div className="f jcsb aic full-width">
          <div className={"f"}>
            <SearchForm />
            <Nav>
              <NavList>
                {navItems.map(({ path, label, Icon }) => (
                  <NavListItem key={label}>
                    <NavListLink
                      exact
                      to={path}
                      activeClassName={"color-primary"}
                    >
                      <div className={"f fdc aic"}>
                        <Icon style={{ fontSize: 18 }} />
                        {typeof label === "string" ? (
                          <span className={"font-12"}>{label}</span>
                        ) : (
                          label
                        )}
                      </div>
                    </NavListLink>
                  </NavListItem>
                ))}
              </NavList>
            </Nav>
          </div>
          <div className="f aic">
            {showNotifications && <NotificationsDropdown {...props} />}
            <UserDropdownMenu {...props} />
          </div>
        </div>
      </div>
    </Container>
  )
}

const mapStateToProps = ({ auth, search }) => ({ auth, search })
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signOut,
      usersSearch,
      getNotificationSmallList,
      clearNotificationSmallList,
      deleteNotification,
      updateNotificationList,
      decrementUnreadCount,
      clearNotificationCount,
    },
    dispatch
  )

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HeaderLoggedIn)
)
